import React from 'react';
import { string, shape } from 'prop-types';
import parse from 'html-react-parser';

export default function SearchListing({ item }) {
    return (
        <div className="c-search-listing">
            <h3><a href={item.url}>{ parse(item.title) }</a></h3>
            <p>{ parse(item.excerpt) }</p>
            <a href={item.url}>{item.url}</a>
            {item.tags.length > 0 &&
                <div className="search-tag">
                    {item.tags.map(tag => (
                        <a key={tag.id} href={tag.url}>{tag.name}</a>
                    ))}
                </div>
            }
        </div>
    );
}

SearchListing.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    item: shape({
        url: string.isRequired,
        title: string.isRequired,
        excerpt: string.isRequired
    }).isRequired
    /* eslint-enable react/no-typos */
};
